var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.965,
    height: 19.332,
    viewBox: "0 0 14.965 19.332",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Lock"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1.5A1.5 1.5 0 1 1 1.5 3 1.5 1.5 0 0 1 0 1.5z",
    transform: "translate(5.982 12.223)",
    style: {
      fill: "#1bc47d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.482 19.332c-1.186 0-2.386-.048-3.569-.142l-1.5-.12A2.357 2.357 0 0 1 .275 17.1a20.836 20.836 0 0 1 0-6.751 2.357 2.357 0 0 1 2.142-1.975L3.1 8.32l-.312-2.839a4.955 4.955 0 0 1 0-1.1l.023-.205a4.7 4.7 0 0 1 9.342 0l.023.205a4.955 4.955 0 0 1 0 1.1L11.86 8.32l.687.055a2.357 2.357 0 0 1 2.142 1.973 20.836 20.836 0 0 1 0 6.751 2.357 2.357 0 0 1-2.142 1.973l-1.5.12a45.56 45.56 0 0 1-3.565.14zm0-9.72a43.19 43.19 0 0 0-3.45.138l-1.5.12a.859.859 0 0 0-.781.719 19.332 19.332 0 0 0 0 6.267.859.859 0 0 0 .781.719l1.5.12a43.071 43.071 0 0 0 6.899 0l1.5-.12a.859.859 0 0 0 .781-.719 19.332 19.332 0 0 0 0-6.267.859.859 0 0 0-.781-.719l-1.5-.12a43.618 43.618 0 0 0-3.449-.137zm0-1.5c.957 0 1.927.031 2.881.093l.321-2.891a3.5 3.5 0 0 0 0-.764l-.023-.205a3.186 3.186 0 0 0-2.806-2.823 3.24 3.24 0 0 0-.747 0A3.184 3.184 0 0 0 4.3 4.346l-.023.205a3.5 3.5 0 0 0 0 .764L4.6 8.206c.96-.062 1.93-.093 2.882-.093z",
    style: {
      fill: "#8c8d99"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.2535c180803a0c0b12d432a70f5d016a.svg";
export { ForwardRef as ReactComponent };